module.exports = __webpack_public_path__ + "media/images/official/special_workcation_mochimuneb_02-8c5037fee4e68ccabe62381da57e440e.jpeg";